import { render } from "./App.vue?vue&type=template&id=fcd14086"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fcd14086&lang=scss"

import exportComponent from "F:\\workfile\\project\\sdk\\sdk.h5.game\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__